import { render, staticRenderFns } from "./SvgRules.vue?vue&type=template&id=10b8ac8c&scoped=true&"
import script from "./SvgRules.vue?vue&type=script&lang=js&"
export * from "./SvgRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b8ac8c",
  null
  
)

export default component.exports